// en.js
export default {
    m: {
        topAlert: {
            detail: 'Click for details'
        },
        bannerSearch: {
            MyTicket: 'My Ticket',
            submit: "Create a Ticket",
            results: 'Search Results'
        },
        header: {
            support: "SUPPORT",
            server: "SERVICE STATUS",
            known: "KNOWN ISSUES",
            submit: "CREATE A TICKET",
            sign: "LOGIN",
            play: "Party Animals Support",
            ticket: "MY TICKETS",
            search: 'Search help articles',
            out: 'LOGOUT',
            media: "MEDIA",
            supportup: "SUPPORT",
            forum: "FORUM",
            creators: "EVENTS",
            en: "Global - English",
            zh: "中国 - 中文",
        },
        banner: {
            title: "HOW CAN WE HELP?",
            support: "Support",
            search: 'Search for articles'
        },
        home: {
            tabsTitle: "CHOOSE A CATEGORY",
            tabsTitles: "",
        },
        contact: {
            title: "STILL NEED HELP?",
            pone: "Submit a ticket!",
            ptwo: "We'll get back to you soon"
        },
        search: {
            one: " result",
            res: " results",
            emply: 'No result',
        },
        topic: {
            all: 'SEE ALL ARTICLES'
        },
        article: {
            office: 'Party Animals',
            help: 'Was this article helpful?',
            yes: 'YES',
            no: 'NO',
            copy: "Copy Link",
            copysuccess: "Copy Success!",
        },

        feature: {
            title: "FEATURED ARTICLES"
        },
        submit: {
            btn: "SUBMIT A TRACKET"
        },
        login: {
            title: 'LOG IN',
            pone: 'Log in to your Party Animals account',
            ptwo: '',
            wechat: 'WECHAT Account',
            qq: 'QQ Account',
            google: 'Google',
            facebook: 'Facebook',
            steam: 'STEAM Account',
            text: 'I agree to the ',
            and: ' and ',
            xbox: 'XBOX LIVE Account',
            eula: 'User Agreement',
            privacy: 'Privacy Policy',
            alert: "This is a required field",
        },
        footer: {
            download: "Downloadable Media",
            follow: "Follow Party Animals on",
            eula: "EULA",
            privacy: "Privacy Policy",
            playersupport: "Player Support",
            press: "Press",
            business: "Business",
            kit: 'Press Kit',
            on: "Follow Party Animals on",
        },
        ticket: {
            limit: 'Supported formats: jpg, jpeg, png, gif, mpg, mpeg, xls, xlsx, ppt, pptx, doc, docx, pdf, word, txt, mp3, mp4, avi, amr, wav, m4a, mov, eml, csv, rar, zip, gz. Total file size should not exceed 50MB',
            alert1: 'This is a required field',
            title: "CREATE A TICKET",
            email: "Email",
            support: "Support ID",
            type: "Type of Issue",
            subcate: "Subcategory",
            subject: "Subject",
            des: "Description",
            attach: "Attachments",
            attachafter: " (optional)",
            alert: "PLEASE NOTE: This is required to solve most issues. We can assist much quicker with this information. Support ID can be found in the Profile tab of the in-game settings",
            alerttwo: "Please enter details of your request, including as much information as possible",
            policy: "I confirm that I am over 13 and have read and understood the",
            policytwo: "PartyAnimals Privacy Policy",
            policythree: "Please note that any feedback or suggestions provided are subject to the",
            policyfour: "PartyAnimals Terms of Service",
            policyfive: ", including specific terms regarding Feedback",
            submit: "SUBMIT",
            MyTicket: "My Ticket",
            cap: "Code",
            codeAlert: "Please enter the correct verification code",
            custid: "CUSTOMER SERVICE ID",
            codeplace: "Please enter the verification code",
            custplace: `Go to "Settings - General - My Customer Service ID" in the game`,
        },
        myticket: {
            sub: 'SUBJECT',
            ticket: 'TICKET ID',
            last: 'LAST UPDATE TIME',
            status: "STATUS ",
            search: "SEARCH TICKETS",
        },
        ticketdetail: {
            emply: 'This is a required field',
            office: 'Party Animals',
            id: "TICKET ID",
            create: 'CREATED',
            support: 'SUPPORT ID',
            email: 'EMAIL',
            statu: "STATUS",
            type: "Type a response",
            drop: "Select File or ",
            dropa: "Drag It Here",
            dropShort:'Attach Files',
            sub: "SUBMIT",
            relpy: "Reply"
        },
        nfind: {
            back: "GO BACK"
        },
        server: {
            running: 'All services up and running',
            error: "Limited usage",
            update: "Last updated 1 minute ago",
            status: "Status Key",
            runningsmall: "Up and Running",
            limit: "Limited",
            bigerror: "Major Issue or Outage",
            serve: "Service Status",
            article: "RELATED ARTICLES",
            report: "REPORT SERVICE ISSUE",
            detail: "If you notice a service issue with Party Animals, please let us know",
            repbtn: "Submit Report",
            help: "Still need help?",
            detail1: "Please submit a ticket. We'll get back to you as soon as possible",
            repbtn1: "Create a ticket",

            Announcement: "Announcement",
            Room: "Custom Game",
            Matching: "Quick Match",
            Login: "Login",
            OfficialSite: "Official Website",
            Store: "Item Shop",
            FriendChat: "Friends & Chat",

            reportTitle: "REPORT A SERVICE ISSUE",
            reportTxt: "What are you having issues with?",
            reportOne: "Choose the service you are having issues with",
            reportSec: "",
            reportTwo: "Describe the issue (optional)",
            reportPlace: "",

            close: "CANCEL",
            submit: "SUBMIT",
        },
        bind: {
            title: "REGISTER YOUR CUSTOMER SERVICE ID",
            span: "Registering your Customer Sevice ID will enable us to address your concerns more efficiently",
            step: `1. Click "Settings" within the game`,
            steptwo: `2. Scroll to the bottom of the "General" tab, find "My Customer Service ID", and click "Inspect"`,
            stepthree: `3. Click the View icon to reveal your Customer Service ID or click the ID itself to conveniently copy it`,
            inputTitle: "Service ID",
            inputPlace: "Please enter your Customer Service ID",
            alert: "Service ID is invalid, please re-enter",
            alertBind: "This Service ID has already been registered to another account, please re-enter",
            jump: "SKIP",
            post: "REGISTER",
            postTitle: "REGISTRATION SUCCESSFUL",
            postSpan: "Your Customer Service ID has been successfully registered",
            postHome: "SUPPORT",
            emply: "Service ID is invalid, please re-enter",
            hasbind: "This Service ID has already been registered to another account, please re-enter",
        },
        notfind: {
            title: '404 ERROR',
            txt: "DOGGONE IT! THE PAGE YOU'RE LOOKING FOR CANNOT BE FOUND",
            btn: 'SUPPORT',
        }
    }
}